
import { createModel } from "hox";
import { globalPrompt } from "@/components/YhMessage";
import useNavModel from "@/model/navModel";
import { IBillDetail } from "../bill/BillTypes";

export const billDetailRenderModel = createModel(function () {

  const branchList = new Set([
    "scm",
    "vrm",
    "bcm",
    "ci",
  ])
  const tradeTypeList = new Set([
    "trade-type.sale",
    "trade-type.sale-return",
    "trade-type.purchase",
    "trade-type.purchase-return",
    "trade-type.maintenance",
    "trade-type.maintenance-return",
    "trade-type.transit-sale",
    "trade-type.transit-sreturn"
  ])
  const { selectedNavId, replaceNav } = useNavModel();

  const goToBill = (text: string, records: IBillDetail) => {

    const { tradeTypeCode, branch } = records

    if (!branchList.has(branch as string)) return globalPrompt("message", { text: "暂不支持查看此系统账单详情", type: "warning" })
    // if (!tradeTypeList.has(tradeTypeCode as string)) return globalPrompt("message", { text: "暂不支持查看此类型账单详情", type: "warning" })
    if (records.tradeTypeCode === 'trade-type.sale-return' && records.branch === "scm") {
      replaceNav(
        selectedNavId,
        "10-1",
        {
          id: records.tradeCode as string,
          mode: '',
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (records.tradeTypeCode === 'trade-type.sale' && records.branch === "scm") {
      replaceNav(
        selectedNavId,
        "10-2",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)

    } else if (records.tradeTypeCode === 'trade-type.purchase-return' && records.branch === "scm") {
      replaceNav(
        selectedNavId,
        "10-4",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (records.tradeTypeCode === 'trade-type.purchase' && records.branch === "scm") {
      replaceNav(
        selectedNavId,
        "10-3",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (records.tradeTypeCode === 'trade-type.sale' && records.branch === "ci") {
      replaceNav(
        selectedNavId,
        "11-2",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (records.tradeTypeCode === 'trade-type.sale-return' && records.branch === "ci") {
      replaceNav(
        selectedNavId,
        "11-1",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (records.tradeTypeCode === 'trade-type.maintenance' && records.branch === "ci") {
      replaceNav(
        selectedNavId,
        "11-5",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (records.tradeTypeCode === 'trade-type.purchase' && records.branch === "ci") {
      replaceNav(
        selectedNavId,
        "11-3",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    }  else if (records.tradeTypeCode === 'trade-type.purchase-return' && records.branch === "ci") {
      replaceNav(
        selectedNavId,
        "11-4",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (records.tradeTypeCode === 'trade-type.sale' && records.branch === "vrm") {
      replaceNav(
        selectedNavId,
        '11-2',
        {
          id: records.tradeCode as string,
          mode: '',
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          },
        },
        true
      );
    }else if (records.tradeTypeCode === 'trade-type.sale-return' && records.branch === "vrm") {
      replaceNav(
        selectedNavId,
        "11-1",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (records.tradeTypeCode === 'trade-type.maintenance-return' && records.branch === "vrm") {
      replaceNav(
        selectedNavId,
        "11-8",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (records.tradeTypeCode === 'trade-type.maintenance' && records.branch === "vrm") {
      replaceNav(
        selectedNavId,
        "11-7",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (records.tradeTypeCode === 'trade-type.purchase-return' && records.branch === "vrm") {
      replaceNav(
        selectedNavId,
        "11-4",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (records.tradeTypeCode === 'trade-type.purchase' && records.branch === "vrm") {
      replaceNav(
        selectedNavId,
        "11-3",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (records.tradeTypeCode === 'trade-type.sale-return' && records.branch === "bcm") {
      replaceNav(
        selectedNavId,
        "12-1",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (records.tradeTypeCode === 'trade-type.sale' && records.branch === "bcm") {
      replaceNav(
        selectedNavId,
        "12-2",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (records.tradeTypeCode === 'trade-type.transit-sale' && records.branch === "bcm") {
      replaceNav(
        selectedNavId,
        "12-7",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (records.tradeTypeCode === 'trade-type.transit-sreturn' && records.branch === "bcm") {
      replaceNav(
        selectedNavId,
        "12-6",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (records.tradeTypeCode === 'trade-type.maintenance' && records.branch === "bcm") {
      replaceNav(
        selectedNavId,
        "12-5",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (records.tradeTypeCode === 'trade-type.purchase-return' && records.branch === "bcm") {
      replaceNav(
        selectedNavId,
        "12-4",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)

    } else if (records.tradeTypeCode === 'trade-type.purchase' && records.branch === "bcm") {
      replaceNav(
        selectedNavId,
        "12-3",
        {
          id: records.tradeCode as string,
          mode: "",
          branch: records.branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    }
  }

  return {
    goToBill
  }
});
